export const footerIcons = {
  facebookIcon: 'assets/img/icon/footer/facebook-icon.svg',
  twitterIcon: 'assets/img/icon/footer/twitter-icon.svg',
  linkedInIcon: 'assets/img/icon/footer/linkedin-icon.svg',
  instagramIcon: 'assets/img/icon/footer/instagram-icon.svg',
  youtubeIcon: 'assets/img/icon/footer/youtube-icon.svg',
  greenCityLogo: 'assets/img/logo-l.svg'
};
